import React from "react"

const UtterancesComments = ({ innerRef }) => {
  return <div ref={innerRef}></div>
}

export default UtterancesComments
